module.exports = __webpack_public_path__ + "img/mrrw.a49b125c.png";